import React, { Component } from 'react';
import './calculator.css'

class Calculator extends Component {
    componentDidMount() {
        const _wiwo = window._wiwo || (window._wiwo = []);
        //_wiwo.push(['init', 'wiwo-biwohadi']);
        _wiwo.push(['initNext']);
    }
    
    render() {
        return (
            <div className="main-container">
                <div className="hsbckf_title">
                    <h1>House Stamp Duty Calculator</h1>
                    </div>
                <div className="hsbckf_description">
                    <p>The property fees calculator helps you estimate the stamp duty, government charges, grants, concessions and associated costs for first home buyers, existing home owners and investors.</p>
                </div>
                <div className="iframe-container">          
                    <iframe id="wiwo-zonire" src="about:blank" data-wiwo-init="paused"></iframe>
                </div>   
            </div>
        );
    }
}

export default Calculator;
